export default __webpack_public_path__ + "static/media/video contest.d6051f52.png";